<template>
  <div ref="container" class="message-notice" v-show="list.length > 0">
    <span @mouseover="pause" @mouseleave="run" ref="message" class="active-msg" :style="{'transform': `translate3d(${translateX}px, 0, 0)`}" @click="goMessage">{{activeMsg}}</span>
  </div>
</template>

<script>
import { messageNoticeList } from '@/api.js'
export default {
  name: 'MessageNotice',
  data() {
    return {
      list: [],
      interval: null, // 计时器实例
      activeMsg: '', // 当前消息
      activeIndex: 0, // 当前消息顺序
      step: 1, // 动画每一步移动
      sleepTime: 10, // 两次动画之间暂停时间
      containerLength: 0, // 容器宽度
      messageLength: 0, // 消息宽度
      translateX: 0, // 当前消息位置
      speed: 20 // 动画速度（越小越快）
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.calcContainerLength()
    })
  },
  methods: {
    calcContainerLength() {
      // 计算容器宽度
      const { container } = this.$refs
      if (container) {
        const { width } = window.getComputedStyle(container)
        this.containerLength = parseInt(width)
      }
    },
    calcMessageLength() {
      // 计算每条消息长度
      const { message } = this.$refs
      if (message) {
        const { width } = window.getComputedStyle(message)
        this.messageLength = parseInt(width) 
      }
    },
    run() {
      // 开始动画（单次）
      this.interval = this.interval || setInterval(async () => {
        if (this.translateX > (0 - this.messageLength)) {
          this.translateX -= this.step
        } else {
          this.stop()
          await this.$utils.sleep(this.sleepTime * 1000)
          this.switchNext()
        }
      }, this.speed)
    },
    calcInitTransX() {
      this.translateX = this.containerLength
    },
    pause() {
      clearInterval(this.interval)
      this.interval = null
    },
    stop() {
      // 停止滚动
      clearInterval(this.interval)
      this.interval = null
      this.activeMsg = ''
    },
    switchNext() {
      // 切换到下一条
      if (this.activeIndex === this.list.length - 1) {
        this.activeIndex = 0
      } else {
        this.activeIndex += 1
      }

      this.activeMsg = this.list[this.activeIndex]
      this.$nextTick(() => {
        this.calcMessageLength()
        this.calcInitTransX()
        this.run()
      })
    },
    getPageListByPath(listData = {}) {
      // 通过路径获取当前页的消息数据
      const { path } = this.$route
      let list = []
      for (const k in listData) {
        if (Object.hasOwnProperty.call(listData, k)) {
          const e = listData[k];
          if (k.includes(path)) {
            list = e || []
          }
        }
      }

      if (listData['all'] && listData['all'].length) {
        list = list.concat(listData['all'])
      }

      return list.sort((a, b) => { return b.time - a.time}).map(i => i.msg)
    },
    async refresh() {
      const list = await this.getList()
      // const pageList = this.getPageListByPath(list)
      // this.list = pageList
      this.list = list
      if (this.list && this.list.length > 0) {
        this.stop()
        this.activeIndex = 0
        this.activeMsg = this.list[0]
        this.$nextTick(() => {
          this.calcContainerLength()
          this.calcMessageLength()
          this.calcInitTransX()
          this.run()
        })
      }
    },
    goMessage() {
      // 跳转消息通知页
      this.$router.push('/inquire/message/index')
    },
    getList() {
      // 获取数据
      return this.$request('get', messageNoticeList)
      .then(res => res)
    },
  }
}
</script>

<style lang="scss" scoped>
  .message-notice {
    width: 100%;
    height: 30px;
    background-color: #fdf6ec;
    color: #e6a23c;
    padding: 0;
    overflow: hidden;
    position: relative;
    .active-msg {
      font-size: 14px;
      line-height: 30px;
      transform: translate3d(9999px, 0, 0);
      position: absolute;
      cursor: pointer;
    }
  }
</style>